
const Focus = () => {
    // Pass single element
    const focus = document.getElementById("newsletter-form");
    const vldbtn= document.getElementById("validation");
    if (focus) {
       focus.addEventListener('click', function handleClick() {
        vldbtn.style.display="block";
       })

    }
}
export default Focus;